import { styled } from "@mui/material/styles";
import { SvgIconWrapper } from "../../svg-icon-wrapper.component";

export const LikeIconWrapper = styled(SvgIconWrapper)({
  width: "2rem",
  height: "2rem",
});
